import React from "react";
import { JsonEditor as ReactJsonEditor, ThemeInput } from "json-edit-react";

const theme: ThemeInput = {
  styles: {
    container: { backgroundColor: "var(--od-surface)", color: "var(--od-text)" },
    collection: { backgroundColor: "var(--od-surface)", color: "var(--od-text)" },
    collectionInner: { backgroundColor: "var(--od-surface)" },
    collectionElement: { backgroundColor: "var(--od-surface)" },
    dropZone: { backgroundColor: "var(--od-surface-2)" },
    property: "var(--od-text)",
    bracket: "var(--od-muted)",
    itemCount: "var(--od-muted)",
    string: "var(--od-text)",
    number: "var(--od-primary-text)",
    boolean: "var(--od-primary-text)",
    null: "var(--od-muted)",
    input: {
      backgroundColor: "var(--od-surface-2)",
      color: "var(--od-text)",
      border: "1px solid var(--od-interactive-boundary)",
    },
    inputHighlight: { backgroundColor: "var(--od-surface-2)", color: "var(--od-text)" },
    error: { backgroundColor: "var(--od-surface)", color: "var(--od-danger)" },
    iconCollection: "var(--od-muted)",
    iconEdit: "var(--od-muted)",
    iconDelete: "var(--od-danger)",
    iconAdd: "var(--od-primary-text)",
    iconCopy: "var(--od-muted)",
    iconOk: "var(--od-primary-text)",
    iconCancel: "var(--od-muted)",
  },
};

type JSONEditorProps = {
  value: any;
  onChange: (value: any) => void;
};

export const JSONEditor = (props: JSONEditorProps) => {
  return (
    <div className="bg-od-surface border border-od-border rounded-lg p-2">
      <ReactJsonEditor data={props.value} setData={props.onChange} theme={theme} />
    </div>
  );
};
